import { LanguageType } from 'types/LanguageType';
import { useLanguageContext } from "contexts/LanguageContext";

export default function useLocalizedLabels(object?: { [k in LanguageType]: object }): object {
  const language = useLanguageContext();
  return object != null ? object[language as keyof typeof object] : {};
}
